var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_vm._v("Accessibilité")]), _vm._v(" "), _c('div', {
    staticClass: "hidden text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 font-normal lg:grid grid-cols-12 gap-x-4 place-content-center"
  }, [_c('div', {
    staticClass: "col-span-7 ml-15"
  }, [_vm._v("Intitulé")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3"
  }, [_vm._v("Nécessité")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1",
    on: {
      "mouseover": function ($event) {
        _vm.isDisplayCommentaireTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.isDisplayCommentaireTooltip = false;
      }
    }
  }, [_c('info-bulle-hover', {
    attrs: {
      "is-display-tooltip": _vm.isDisplayCommentaireTooltip,
      "name": "commentaireTooltip",
      "libelle": "Commentaires"
    }
  }), _vm._v("\n                Comm.\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-4 lg:block px-2 lg:px-0"
  }, [_c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "reperage_cheminements_exterieurs"
    }
  }, [_vm._v("\n                    Repérage des cheminements extérieurs\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "reperage_cheminements_exterieurs",
      "necessary": true,
      "value": _vm.form.reperage_cheminements_exterieurs,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Repérage des cheminements extérieurs' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.reperage_cheminements_exterieurs = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "reperage_cheminements_exterieurs_comment",
      "value": _vm.form.reperage_cheminements_exterieurs_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.reperage_cheminements_exterieurs_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "guidage_cheminements_exterieurs"
    }
  }, [_vm._v("\n                    Guidage des cheminements extérieurs\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "guidage_cheminements_exterieurs",
      "necessary": true,
      "value": _vm.form.guidage_cheminements_exterieurs,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Guidage des cheminements extérieurs' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.guidage_cheminements_exterieurs = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "guidage_cheminements_exterieurs_comment",
      "value": _vm.form.guidage_cheminements_exterieurs_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.guidage_cheminements_exterieurs_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start mr-48",
    attrs: {
      "for": "prevention_element_chemin_exterieur"
    }
  }, [_vm._v("\n                    Prévention d'éléments empiétant sur le chemin extérieur (au dessus du sol, prés du sol, etc.)\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "prevention_element_chemin_exterieur",
      "necessary": true,
      "value": _vm.form.prevention_element_chemin_exterieur,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Prévention d\'éléments empiétant sur le chemin extérieur (au dessus du sol, prés du sol, etc.)' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.prevention_element_chemin_exterieur = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "prevention_element_chemin_exterieur_comment",
      "value": _vm.form.prevention_element_chemin_exterieur_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.prevention_element_chemin_exterieur_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "dispositifs_commande_acces"
    }
  }, [_vm._v("\n                    Dispositifs de commande d'accès / sortie ou de communication\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "dispositifs_commande_acces",
      "necessary": true,
      "value": _vm.form.dispositifs_commande_acces,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Dispositifs de commande d\'accès / sortie ou de communication' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.dispositifs_commande_acces = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "dispositifs_commande_acces_comment",
      "value": _vm.form.dispositifs_commande_acces_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.dispositifs_commande_acces_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap",
    class: {
      'h-auto pt-6': _vm.form.dimensionnement_portes_circulation == 'Nécessaire'
    }
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "dimensionnement_portes_circulation"
    }
  }, [_vm._v("\n                    Dimensionnement des portes de circulation et des accès type sas\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "dimensionnement_portes_circulation",
      "necessary": true,
      "value": _vm.form.dimensionnement_portes_circulation,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Dimensionnement des portes de circulation et des accès type sas' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.dimensionnement_portes_circulation = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "dimensionnement_portes_circulation_comment",
      "value": _vm.form.dimensionnement_portes_circulation_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.dimensionnement_portes_circulation_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.form.dimensionnement_portes_circulation == 'Nécessaire' ? _c('div', {
    staticClass: "ml-20 my-6 col-start-1 col-span-full grid grid-cols-12 gap-4"
  }, [_c('checkbox-indigo', {
    staticClass: "col-span-10 md:col-span-5 md:ml-15",
    attrs: {
      "name": "espace_manoeuvre_frontal",
      "libelle": "Espace de manoeuvre frontal",
      "value": _vm.form.espace_manoeuvre_frontal
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre_frontal = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "espace_manoeuvre_frontal_comment",
      "value": _vm.form.espace_manoeuvre_frontal_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre_frontal_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "espace_manoeuvre_lateral",
      "libelle": "Espace de manoeuvre lateral",
      "value": _vm.form.espace_manoeuvre_lateral
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre_lateral = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "espace_manoeuvre_lateral_comment",
      "value": _vm.form.espace_manoeuvre_lateral_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre_lateral_comment = newValue;
      }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap",
    class: {
      'h-auto pt-6': _vm.form.reperage_portes_poignees == 'Nécessaire'
    }
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "reperage_portes_poignees"
    }
  }, [_vm._v("\n                    Repérage des portes et poignées\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "reperage_portes_poignees",
      "necessary": true,
      "value": _vm.form.reperage_portes_poignees,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Repérage des portes et poignées' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.reperage_portes_poignees = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "reperage_portes_poignees_comment",
      "value": _vm.form.reperage_portes_poignees_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.reperage_portes_poignees_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.form.reperage_portes_poignees == 'Nécessaire' ? _c('div', {
    staticClass: "ml-20 my-6 col-span-full grid grid-cols-12 gap-4"
  }, [_c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "contraste_environnement",
      "libelle": "Contraste par rapport à l'environnement",
      "value": _vm.form.contraste_environnement
    },
    on: {
      "input": function (newValue) {
        _vm.form.contraste_environnement = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "contraste_environnement_comment",
      "value": _vm.form.contraste_environnement_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.contraste_environnement_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "espace_manoeuvre",
      "libelle": "Espace de Manoeuvre",
      "value": _vm.form.espace_manoeuvre
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "espace_manoeuvre_comment",
      "value": _vm.form.espace_manoeuvre_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_manoeuvre_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "poignees_prehensible_assise",
      "libelle": "Poignée préhensible en position assise",
      "value": _vm.form.poignees_prehensible_assise
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignees_prehensible_assise = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "poignees_prehensible_assise_comment",
      "value": _vm.form.poignees_prehensible_assise_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignees_prehensible_assise_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "poignee_prehensible_droite",
      "libelle": "Poignée préhensible droite",
      "value": _vm.form.poignee_prehensible_droite
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignee_prehensible_droite = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "poignee_prehensible_droite_comment",
      "value": _vm.form.poignee_prehensible_droite_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignee_prehensible_droite_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "poignee_prehensible_gauche",
      "libelle": "Poignée préhensible gauche",
      "value": _vm.form.poignee_prehensible_gauche
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignee_prehensible_gauche = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "poignee_prehensible_gauche_comment",
      "value": _vm.form.poignee_prehensible_gauche_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.poignee_prehensible_gauche_comment = newValue;
      }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "montees_marches"
    }
  }, [_vm._v("\n                    Montées de marches\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "montees_marches",
      "necessary": true,
      "value": _vm.form.montees_marches,
      "datas": [{
        value: 'Possible'
      }, {
        value: 'Impossible'
      }, {
        value: 'Rampe d\'accès amovible obligatoire'
      }],
      "libelle": _vm.$isMobile() ? 'Montées de marches' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.montees_marches = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "montees_marches_comment",
      "value": _vm.form.montees_marches_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.montees_marches_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "montees_escaliers"
    }
  }, [_vm._v("\n                    Montées d'escaliers\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "montees_escaliers",
      "necessary": true,
      "value": _vm.form.montees_escaliers,
      "datas": [{
        value: 'Possible'
      }, {
        value: 'Impossible'
      }, {
        value: 'Main courante obligatoire'
      }, {
        value: 'Rampe d\'accès amovible obligatoire'
      }],
      "libelle": _vm.$isMobile() ? 'Montées d\'escaliers' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.montees_escaliers = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "montees_escaliers_comment",
      "value": _vm.form.montees_escaliers_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.montees_escaliers_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_vm._m(0), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "prevention_elements_chemin_interieur",
      "necessary": true,
      "value": _vm.form.prevention_elements_chemin_interieur,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Prévention d\'éléments empiétant sur le cheminement intérieur (au-dessus du sol, près du sol, latéral, etc...)' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.prevention_elements_chemin_interieur = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "prevention_elements_chemin_interieur_comment",
      "value": _vm.form.prevention_elements_chemin_interieur_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.prevention_elements_chemin_interieur_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "information_signalisation_interieure"
    }
  }, [_vm._v("\n                    Information et signalisation intérieure\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "information_signalisation_interieure",
      "necessary": true,
      "value": _vm.form.information_signalisation_interieure,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Information et signalisation intérieure' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.information_signalisation_interieure = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "information_signalisation_interieure_comment",
      "value": _vm.form.information_signalisation_interieure_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.information_signalisation_interieure_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4"
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "EPMR_vertical"
    }
  }, [_vm._v("\n                    Ascenseur adapté/ EPMR Vertical (Elévateur pour Personnes à Mobilité Réduite)\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "EPMR_vertical",
      "necessary": true,
      "value": _vm.form.EPMR_vertical,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Ascenseur adapté/ EPMR Vertical (Elévateur pour Personnes à Mobilité Réduite)' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.EPMR_vertical = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "EPMR_vertical_comment",
      "value": _vm.form.EPMR_vertical_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.EPMR_vertical_comment = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap",
    class: {
      'h-auto pt-6': _vm.form.amenagement_toilettes == 'Nécessaire'
    }
  }, [_c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "amenagement_toilettes"
    }
  }, [_vm._v("\n                    Aménagement Toilettes\n                ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3 max-w-9/12",
    attrs: {
      "name": "amenagement_toilettes",
      "necessary": true,
      "value": _vm.form.amenagement_toilettes,
      "datas": [{
        value: 'Nécessaire'
      }, {
        value: 'Inutile'
      }],
      "libelle": _vm.$isMobile() ? 'Aménagement Toilettes' : null
    },
    on: {
      "input": function (newValue) {
        _vm.form.amenagement_toilettes = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-1 lg:place-self-center w-max",
    attrs: {
      "name": "amenagement_toilettes_comment",
      "value": _vm.form.amenagement_toilettes_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.amenagement_toilettes_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.form.amenagement_toilettes == 'Nécessaire' ? _c('div', {
    staticClass: "ml-20 my-6 col-span-full grid grid-cols-12 gap-4"
  }, [_c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "espace_transfert_frontal",
      "libelle": "Espace de transfert frontal",
      "value": _vm.form.espace_transfert_frontal
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_transfert_frontal = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "espace_transfert_frontal_comment",
      "value": _vm.form.espace_transfert_frontal_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_transfert_frontal_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "espace_transfert_lateral",
      "libelle": "Espace de transfert latéral",
      "value": _vm.form.espace_transfert_lateral
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_transfert_lateral = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "espace_transfert_lateral_comment",
      "value": _vm.form.espace_transfert_lateral_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.espace_transfert_lateral_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    staticClass: "col-span-10 lg:col-start-1 md:col-span-5 md:ml-15",
    attrs: {
      "name": "hauteur_wc_respecter",
      "libelle": "Hauteur des WC à respecter (Abattant inclus)",
      "value": _vm.form.hauteur_wc_respecter
    },
    on: {
      "input": function (newValue) {
        _vm.form.hauteur_wc_respecter = newValue;
      }
    }
  }), _vm._v(" "), _c('icon-comment', {
    staticClass: "col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max",
    attrs: {
      "name": "hauteur_wc_respecter_comment",
      "value": _vm.form.hauteur_wc_respecter_comment,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.hauteur_wc_respecter_comment = newValue;
      }
    }
  })], 1) : _vm._e()])], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start",
    attrs: {
      "for": "prevention_elements_chemin_interieur"
    }
  }, [_vm._v("\n                    Prévention d'éléments empiétant sur le cheminement intérieur "), _c('br'), _vm._v(" (au-dessus du sol, près du sol, latéral, etc...)\n                ")]);

}]

export { render, staticRenderFns }